import React, { useEffect } from "react";
import { PageLayout } from "../components/page-layout";
import { getPublicResource } from "../services/message.service";
import PricingSelector from "../components/PricingSelector";
import FAQ from "../components/faq";

export const Pricing = () => {
  useEffect(() => {
    const getMessage = async () => {
      await getPublicResource();
    };

    getMessage();
  }, []);

  return (
    <PageLayout>
      <div className="content-layout">
        <h1 id="page-title" className="content__title">
          Priser og pakker
        </h1>
        <p className="content__description">
          Få <strong>15%</strong> rabatt med årlig fakturering!
        </p>
        <div className="pricing__container">
          <PricingSelector />
        </div>
        <div className="faq__container">
          <h2 className="faq__title">Ofte stilte spørsmål</h2>
          <FAQ />
        </div>
      </div>
    </PageLayout>
  );
};

export default Pricing;
